<!-- 移动端页头 -->
<template>
  <div :style="headerStyles" class="grid items-center justify-between gap-3.5 p-3">
    <icon name="icon:mobmenu" style="grid-area: menu" class="text-5.5" @click="activeSidebar" />
    <nuxt-link style="grid-area: buttons" to="/search" class="flex-center">
      <icon v-if="datas.settings.header.settings.resch" name="icon:resch" class="text-5.5" />
    </nuxt-link>
    <div style="grid-area: logo" :class="`${mobile_menu_entrance == 'left' ? 'flex-center transform-translate-x--5%' : ''}`">
      <BlocksHeadersComponentsLogo :datas :image="datas.settings.header.settings.mob_image" />
    </div>

    <!-- 工具菜单 -->
    <div style="grid-area: tools" class="justify-self-end gap-2.5">
      <BlocksHeadersComponentsBag :datas="datas" :count="count" />
    </div>

    <!-- 弹出菜单列表 -->
    <n-drawer v-model:show="showSidebar" :placement height="100%" width="88%">
      <n-drawer-content body-content-class="p-0!" closable>
        <n-menu
          dropdown-placement="bottom"
          :root-indent="10"
          :indent="10"
          :options="menuOptions_Mob"
          style="padding: 0px"
        />
        <template #footer>
          <n-flex vertical class="w-100%">
            <n-select v-if="headerSettings?.currency && languageList.currency?.length && languageList.currency?.length > 1" v-model:value="currency_code" size="large" :placeholder="$t('headers.currency')" :options="languageList.currency" label-field="name" value-field="code" @update:value="handleSelectFinance" />
            <n-select v-if="headerSettings?.Language && languageList.langs?.length && languageList.langs?.length > 1" v-model:value="language" size="large" :placeholder="$t('headers.language')" :options="languageList.langs" label-field="name" value-field="code" />
            <n-menu
              v-if="menuOptionsMobile.length"
              style="padding: 0 5px; width: 100%"
              :options="menuOptionsMobile"
            />
            <!-- 登录按钮 -->
            <n-button v-show="!ukey" size="large" block type="primary" class="w100% uppercase" @click="goLogin">
              <span class="m-l15px uppercase">{{ $t('headers.login') }}</span>
            </n-button>
            <n-button v-show="ukey" size="large" block type="primary" class="w100% uppercase" @click="logout">
              <span class="m-l15px uppercase">{{ $t('headers.logout') }}</span>
            </n-button>
          </n-flex>
        </template>
      </n-drawer-content>
    </n-drawer>
  </div>
</template>

<script lang="tsx" setup>
import type { DropdownOption } from 'naive-ui'
import type { StyleValue } from 'vue'
import { loginOut } from '~/services/api'

const props = defineProps<{
  datas: any
  /**  购物车数量 */
  count: any
  /**  菜单项 */
  menuOptions: any
  /**  移动端菜单 */
  menuOptions_Mob: any
}>()
const { showSidebar } = storeToRefs(useShopCart())
const { ukey, currency_code, finance, language, PHPSESSID } = storeToRefs(useUserInfo())

const router = useRouter()

const { languageList, settings } = storeToRefs(useThemeEditorStore())

/**  移动端菜单弹出方向 */
const placement = computed(() => settings.value?.header.settings?.mobile_menu_style ?? 'left')
/**  菜单图标位置 */
const mobile_menu_entrance = computed(() => settings.value?.header.settings?.mobile_menu_entrance ?? 'left')
const headerSettings = computed(() => props.datas?.settings?.header?.settings)

/**  登录 */
const goLogin = () => {
  router.push('/account/login')
}

/**  菜单 */
const { t } = useI18n()

const activeSidebar = () => {
  showSidebar.value = true
}
/**  选择语言货币 */
const handleSelectFinance = (key: string, option: DropdownOption) => {
  finance.value = option.finance as string
}
/**  移动端菜单 */
const menuOptionsMobile = computed(() => {
  if (ukey.value) {
    return [
      {
        label: () => (
          <div
            onClick={() => {
              navigateTo('/account/orders')
            }}
          >
            {t('headers.orders')}
          </div>
        ),
        key: '/account/orders',
      },
      {
        label: () => (
          <div
            onClick={() => {
              navigateTo('/account/address')
            }}
          >
            {t('headers.address')}
          </div>
        ),
        key: '/account/address',
      },
    ]
  }
  return []
})

// /**  语言列表自定义渲染函数 */
// const renderLabelcurrencyOptions = (option: SelectOption | SelectGroupOption): VNodeChild => {
//   return (
//     <div class="flex gap-2">
//       <sps-img
//         class="h-20px"
//         height="20"
//         fit="contain"
//         src={`http://imgs.shopssea.com/public/image/countrys/${option.gcode}.svg`}
//       />
//       <span>{option.name}</span>
//     </div>
//   )
// }
// const renderLabellanguageOptions = (option: SelectOption | SelectGroupOption): VNodeChild => {
//   return (
//     <div class="flex gap-2">
//       <sps-img
//         class="h-20px"
//         height="20"
//         fit="contain"
//         src={`http://imgs.shopssea.com/public/image/countrys/${option.code}.svg`}
//       />
//       <span>{option.name}</span>
//     </div>
//   )
// }

/**  退出登录 */
const logout = async () => {
  await loginOut()
  ukey.value = null
  PHPSESSID.value = null
  showSidebar.value = false
  router.push('/')
}

/**  头部样式:grid布局 */
const headerStyles = computed<Partial<StyleValue>>(() => {
  if (mobile_menu_entrance.value == 'left') {
    return `grid-template: "menu buttons logo tools" / auto auto 1fr auto;`
  }
  return `grid-template: "logo buttons tools menu" /1fr auto auto auto;`
})

prefetchComponents(['BlocksSearch, BlocksAddress', 'BlocksMyOrder'])
</script>

<style lang="scss" scoped>
:deep(.n-menu .n-menu-item-content):has(.n-base-icon.n-menu-item-content__arrow) .n-menu-item-content-header a::before {
  width: 50%;
}
// :deep(.n-menu-item) {
//   border-bottom: 1px solid #ccc;
// }
:deep(.n-menu .n-menu-item-content:not(.n-menu-item-content--disabled):hover::before) {
  background-color: transparent;
}
</style>
